export default __webpack_public_path__ + "bg21e4a17.png";